import React, { Component } from 'react'
import { connect } from 'react-redux'
import { seenMessage } from 'actions/profile'
import { messagesSelector } from 'selectors'
import Modal from 'components/layout/Modal'
import without from 'lodash/without'
import pick from 'lodash/pick'

class Messages extends Component {

  state = {
    neverShow: false,
  }

  handleSeen = id => () => {
    this.props.dispatch(seenMessage(id))

    if (this.state.neverShow) {
      const arr = JSON.parse(localStorage.getItem('roadie-messages-nevershow')) || []
      if (!arr.includes(id)) {
        arr.push(id)
      }

      localStorage.setItem('roadie-messages-nevershow', JSON.stringify(arr))
      this.setState({ neverShow: false })
    }
  }

  getAppMessages() {
    const { appRootPath, messages } = this.props
    if (appRootPath.match(/\/(.*)/)) {
      const app = appRootPath.match(/\/(.*)/)[1]
      const appMessagesIds = Object.keys(messages.all).filter(id => messages.all[id].apps.includes(app))
      const appMessages = pick(messages.all, appMessagesIds)
      return appMessages
    }
    return {}
  }
  
  render() {
    const appMessages = this.getAppMessages()
    const allIds = Object.keys(appMessages)
    const seenIds = this.props.messages.seen
    const neverShowIds = JSON.parse(localStorage.getItem('roadie-messages-nevershow')) || []
    const unseenIds = without(allIds, ...seenIds, ...neverShowIds)

    if (!unseenIds.length || this.props.messagesSkipped) {
      return null
    }

    const current = appMessages[unseenIds[0]]

    return (
      <Modal.Message
        key={current.id}
        title={current.title}
        onNeverShow={(event) => this.setState({ neverShow: !!event.target.checked })}
        onRequestClose={this.handleSeen(current.id)}
      >
        {current.message}
      </Modal.Message>
    )
  }
}

export default connect(messagesSelector)(Messages)